module.exports = __webpack_public_path__ + "img/black-close.c6c55cb6.svg";